export default "__VITE_ASSET__38c6a0b1__"